

import CommonApi from './../commonApi';
import { fetchRequest, initialFetchListParams } from './';








const kasko = new CommonApi('kasko', 'Каско') as CommonApi<any> & {
  fetchByVehicle: (vehicleId: number, params?: any) => Promise<any>;
};

kasko.fetchByVehicle = async (
vehicleId,
params = initialFetchListParams) =>
{
  const kasko = await fetchRequest.get(`/kasko/vehicle/${vehicleId}`, {
    ...initialFetchListParams,
    ...params
  });
  if (kasko) return kasko;
  throw new Error('Не удалось получить список КАСКО');
};

export default kasko;
